<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title']
            }),
            {
              component: 'h3',
              innerText: 'Elementy'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title']),
                fields: [
                  new fields.Input({
                    label: 'Pytanie',
                    modelPath: [this, 'form', 'items', i, 'title']
                  }),
                  new fields.WYSIWYG({
                    label: 'Odpowiedź',
                    modelPath: [this, 'form', 'items', i, 'text']
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
